export const en = {
  // --- FRUITS ---
  apple: ['apple', 'apples', 'granny smith'],
  banana: ['banana', 'bananas'],
  cherry: ['cherry', 'cherries'],
  grape: ['grape', 'grapes', 'raisin'],
  citrus: ['citrus', 'lime', 'mandarin', 'tangerine', 'grapefruit'],
  orange: ['orange', 'oranges'],
  lemon: ['lemon', 'lemons'],
  melon: ['melon', 'watermelon', 'cantaloupe', 'honeydew'],
  pineapple: ['pineapple'],
  avocado: ['avocado'],
  berry: ['berry', 'strawberry', 'blueberry', 'raspberry', 'cranberry', 'blackberry'],
  fruit: ['fruit', 'fruits', 'kiwi', 'plum', 'fig', 'pomegranate', 'apricot'],
  peach: ['peach', 'nectarine'],
  pear: ['pear', 'pears'],
  mango: ['mango'],
  jam: ['jam', 'marmalade', 'jelly', 'preserve', 'spread'],
  honey: ['honey'],

  // --- VEGETABLES ---
  carrot: ['carrot', 'carrots'],
  corn: ['corn', 'maize', 'sweetcorn'],
  salad: ['salad', 'lettuce', 'arugula', 'romaine'],
  spinach: ['spinach', 'spinach leaves'],
  mushroom: ['mushroom', 'champignon', 'portobello'],
  onion: ['onion', 'garlic', 'scallion', 'shallot'],
  leek: ['leek'],
  beetroot: ['beetroot', 'beet'],
  sauerkraut: ['sauerkraut'],
  potato: ['potato', 'potatoes', 'sweet potato'],
  fries: ['fries', 'french fries', 'chips'],
  tomato: ['tomato', 'tomatoes'],
  pepper: ['pepper', 'bell pepper', 'chili', 'jalapeno'],
  veg: ['vegetable', 'veg', 'cabbage', 'eggplant', 'pumpkin', 'bean'],
  celery: ['celery', 'celeriac'],
  sprouts: ['sprouts', 'bean sprouts', 'cress'],
  pak_choi: ['pak choi', 'bok choy'],
  broccoli: ['broccoli'],
  cucumber: ['cucumber'],
  pickles: ['pickles', 'gherkin'],
  zucchini: ['zucchini', 'courgette'],
  cauliflower: ['cauliflower'],
  soup_greens: ['soup greens', 'soup vegetables'],
  peas: ['pea', 'peas', 'chickpeas'],
  snow_peas: ['snow peas', 'sugar snap peas'],

  // --- DAIRY & EGGS ---
  milk: ['milk', 'whole milk', 'skim milk', 'soy milk', 'almond milk'],
  oatmilk: ['oat milk'],
  cheese: ['cheese', 'cheddar', 'mozzarella', 'parmesan', 'feta', 'brie', 'camembert', 'gouda', 'swiss cheese', 'cream cheese', 'ricotta'],
  egg: ['egg', 'eggs'],
  butter: ['butter', 'margarine'],
  yogurt: ['yogurt', 'yoghurt', 'greek yogurt', 'kefir'],
  dairy: ['pudding', 'dairy'],
  cream: ['cream', 'whipping cream', 'heavy cream'],
  sour_cream: ['sour cream', 'creme fraiche'],

  // --- BAKERY ---
  bread: ['bread', 'loaf', 'whole wheat', 'white bread', 'toast'],
  rolls: ['roll', 'rolls', 'bun', 'buns', 'hot dog bun'],
  burger_bun: ['burger bun', 'hamburger bun', 'brioche bun'],
  baguette: ['baguette', 'french bread'],
  croissant: ['croissant'],
  cookie: ['cookie', 'cookies', 'biscuit'],
  cake: ['cake', 'muffin', 'cupcake', 'donut', 'pastry', 'pie', 'tart'],
  pizza: ['pizza', 'pizza dough'],
  sandwich: ['sandwich', 'burger', 'cheeseburger', 'sub'],
  flour: ['flour', 'wheat flour', 'cornstarch', 'yeast', 'breadcrumbs', 'starch'],
  baking_powder: ['baking powder', 'baking soda'],

  // --- MEAT & FISH ---
  meat: ['meat', 'beef', 'pork', 'lamb', 'veal', 'ground beef', 'mince'],
  bbq_meat: ['bbq meat', 'steak', 'ribs', 'grill meat'],
  tofu: ['tofu', 'tempeh', 'seitan'],
  chicken: ['chicken', 'turkey', 'poultry', 'wing', 'breast', 'thigh'],
  fish: ['fish', 'salmon', 'tuna', 'trout', 'cod', 'fish sticks'],
  seafood: ['seafood', 'shrimp', 'prawn', 'mussel', 'squid', 'calamari', 'crab', 'lobster'],
  sausage: ['sausage', 'hot dog', 'frankfurter', 'salami', 'bratwurst', 'pepperoni'],
  bacon: ['bacon', 'ham', 'prosciutto', 'pancetta'],
  bacon_cubes: ['bacon cubes', 'diced bacon'],

  // --- PANTRY & GRAINS ---
  rice: ['rice', 'basmati', 'jasmine', 'risotto'],
  pasta: ['pasta', 'penne', 'fusilli', 'macaroni'],
  spaghetti: ['spaghetti'],
  tortellini: ['tortellini', 'ravioli', 'gnocchi', 'lasagna'],
  lasagna: ['lasagna', 'lasagne'],
  noodles: ['noodles', 'ramen', 'udon', 'vermicelli'],
  cereal: ['cereal', 'oats', 'oatmeal', 'cornflakes', 'granola', 'muesli'],
  oil: ['oil', 'olive oil', 'vegetable oil', 'vinegar', 'balsamic'],
  spice: ['spice', 'salt', 'pepper', 'herb', 'seasoning', 'cinnamon', 'vanilla', 'basil', 'oregano', 'parsley', 'thyme', 'paprika', 'curry'],
  broth: ['broth', 'stock', 'vegetable broth', 'chicken stock', 'beef stock', 'bouillon'],
  sugar: ['sugar', 'honey', 'syrup', 'maple syrup', 'sweetener'],
  canned: ['can', 'tin', 'canned', 'beans', 'jar', 'soup'],
  lentils: ['lentils'],
  sauce: ['sauce', 'ketchup', 'mayo', 'mayonnaise', 'mustard', 'gravy', 'bbq sauce', 'dressing'],
  dip: ['dip', 'guacamole', 'salsa', 'tzatziki'],
  hummus: ['hummus'],

  // --- SNACKS & SWEETS ---
  candy: ['candy', 'sweet', 'lolly', 'gum', 'gummy'],
  praline: ['praline', 'chocolates', 'box of chocolates'],
  chocolate: ['chocolate', 'choc', 'bar', 'truffle'],
  chips: ['chip', 'chips', 'crisp', 'nacho', 'tortilla', 'cracker'],
  pretzel_sticks: ['pretzel sticks', 'pretzels', 'pretzel'],
  ice_cream: ['ice cream', 'popsicle', 'gelato', 'sorbet'],
  popcorn: ['popcorn'],
  nut: ['nut', 'nuts', 'cashew', 'pistachio', 'trail mix'],
  peanut: ['peanut', 'peanuts'],
  almond: ['almond', 'almonds'],
  walnut: ['walnut', 'walnuts'],

  // --- BEVERAGES ---
  water: ['water', 'mineral water', 'sparkling water', 'bottled water'],
  drinks: ['drinks', 'beverages', 'soda'],
  coffee: ['coffee', 'bean', 'espresso', 'cappuccino', 'latte', 'pod'],
  tea: ['tea', 'chai', 'matcha', 'herbal tea'],
  soda: ['soda', 'coke', 'cola', 'pepsi', 'sprite', 'fanta', 'lemonade', 'energy drink', 'soft drink', 'tonic', 'tonic water'],
  juice: ['juice', 'orange juice', 'apple juice', 'smoothie'],
  beer: ['beer', 'lager', 'ale', 'stout', 'pilsner', 'ipa'],
  wine: ['wine', 'rose', 'champagne', 'prosecco'],
  red_wine: ['red wine', 'merlot', 'cabernet'],
  white_wine: ['white wine', 'chardonnay', 'sauvignon'],
  alcohol: ['alcohol', 'spirit', 'vodka', 'gin', 'rum', 'whiskey', 'tequila', 'liquor'],

  // --- HOUSEHOLD & HEALTH ---
  toilet_paper: ['toilet paper', 'tissue', 'paper towel', 'napkin'],
  soap: ['soap', 'hand wash', 'body wash', 'shower gel'],
  cleaning: ['cleaning', 'detergent', 'cleaner', 'bleach', 'sponge', 'dishwasher', 'laundry', 'descaler', 'paper towel'],
  napkins: ['napkin', 'serviette', 'tissue'],
  medicine: ['medicine', 'pill', 'tablet', 'painkiller', 'vitamin', 'band-aid', 'plaster'],
  baby: ['baby', 'diaper', 'nappy', 'wipes', 'pacifier'],
  pet: ['pet', 'dog food', 'cat food', 'treat', 'litter'],
  flower: ['flower', 'plant', 'bouquet'],
  gift: ['gift', 'present', 'card', 'wrapping'],
  party: ['party', 'birthday', 'balloon', 'candle', 'streamer'],
  battery: ['battery'],
  trash: ['trash bag', 'bin liner', 'garbage bag'],
};